// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-frame {
  width: 100%;
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.ad-slot {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.ad-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.ad-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ad-frame.homepage-ad,
.ad-frame.detail-ad,
.ad-frame.download-ad,
.ad-frame.search-ad,
.ad-frame.custom-list-ad {
  height: auto;
  min-height: 0;
  max-height: none;
}

.ad-frame.homepage-ad .ad-slot,
.ad-frame.detail-ad .ad-slot,
.ad-frame.download-ad .ad-slot,
.ad-frame.custom-list-ad .ad-slot,
.ad-frame.homepage-ad .ad-container,
.ad-frame.detail-ad .ad-container,
.ad-frame.download-ad .ad-container,
.ad-frame.custom-list-ad .ad-container,
.ad-frame.homepage-ad .ad-content,
.ad-frame.detail-ad .ad-content,
.ad-frame.download-ad .ad-content,
.ad-frame.custom-list-ad .ad-content {
  height: auto;
  min-height: 0;
}

.ad-frame.search-ad .ad-slot,
.ad-frame.search-ad .ad-container,
.ad-frame.search-ad .ad-content {
  height: auto;
  min-height: 0;
}

.ad-content .adsbygoogle {
  display: block !important;
  width: 100%;
}

.ad-content .adsbygoogle > div[id^="aswift_"][id\$="_host"] {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ad-frame {
    margin: 12px 0;
  }

  .ad-frame.homepage-ad,
  .ad-frame.detail-ad,
  .ad-frame.download-ad,
  .ad-frame.search-ad,
  .ad-frame.custom-list-ad {
    height: auto;
    min-height: 0;
    max-height: none;
  }

  .ad-frame.homepage-ad .ad-slot,
  .ad-frame.detail-ad .ad-slot,
  .ad-frame.download-ad .ad-slot,
  .ad-frame.search-ad .ad-slot,
  .ad-frame.custom-list-ad .ad-slot,
  .ad-frame.homepage-ad .ad-container,
  .ad-frame.detail-ad .ad-container,
  .ad-frame.download-ad .ad-container,
  .ad-frame.search-ad .ad-container,
  .ad-frame.custom-list-ad .ad-container,
  .ad-frame.homepage-ad .ad-content,
  .ad-frame.detail-ad .ad-content,
  .ad-frame.download-ad .ad-content,
  .ad-frame.search-ad .ad-content,
  .ad-frame.custom-list-ad .ad-content {
    height: auto;
    min-height: 0;
  }

  .ad-content .adsbygoogle {
    width: 100%;
  }

  .ad-frame:has(.adsbygoogle[data-ad-status="unfilled"]) {
    display: none;
  }
}

/* 确保广告内容居中显示 */
.ad-content iframe,
.ad-content ins,
.ad-content div {
  margin: 0 auto;
}

/* 广告加载时的占位样式 */
.ad-container:empty::before {
  content: '';
  display: block;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Ad/Ad.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE;IACE,cAAc;EAChB;;EAEA;;;;;IAKE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;;IAeE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,eAAe;AACf;;;EAGE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".ad-frame {\n  width: 100%;\n  margin: 16px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f8f9fa;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ad-slot {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n}\n\n.ad-container {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ad-content {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ad-frame.homepage-ad,\n.ad-frame.detail-ad,\n.ad-frame.download-ad,\n.ad-frame.search-ad,\n.ad-frame.custom-list-ad {\n  height: auto;\n  min-height: 0;\n  max-height: none;\n}\n\n.ad-frame.homepage-ad .ad-slot,\n.ad-frame.detail-ad .ad-slot,\n.ad-frame.download-ad .ad-slot,\n.ad-frame.custom-list-ad .ad-slot,\n.ad-frame.homepage-ad .ad-container,\n.ad-frame.detail-ad .ad-container,\n.ad-frame.download-ad .ad-container,\n.ad-frame.custom-list-ad .ad-container,\n.ad-frame.homepage-ad .ad-content,\n.ad-frame.detail-ad .ad-content,\n.ad-frame.download-ad .ad-content,\n.ad-frame.custom-list-ad .ad-content {\n  height: auto;\n  min-height: 0;\n}\n\n.ad-frame.search-ad .ad-slot,\n.ad-frame.search-ad .ad-container,\n.ad-frame.search-ad .ad-content {\n  height: auto;\n  min-height: 0;\n}\n\n.ad-content .adsbygoogle {\n  display: block !important;\n  width: 100%;\n}\n\n.ad-content .adsbygoogle > div[id^=\"aswift_\"][id$=\"_host\"] {\n  display: block !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .ad-frame {\n    margin: 12px 0;\n  }\n\n  .ad-frame.homepage-ad,\n  .ad-frame.detail-ad,\n  .ad-frame.download-ad,\n  .ad-frame.search-ad,\n  .ad-frame.custom-list-ad {\n    height: auto;\n    min-height: 0;\n    max-height: none;\n  }\n\n  .ad-frame.homepage-ad .ad-slot,\n  .ad-frame.detail-ad .ad-slot,\n  .ad-frame.download-ad .ad-slot,\n  .ad-frame.search-ad .ad-slot,\n  .ad-frame.custom-list-ad .ad-slot,\n  .ad-frame.homepage-ad .ad-container,\n  .ad-frame.detail-ad .ad-container,\n  .ad-frame.download-ad .ad-container,\n  .ad-frame.search-ad .ad-container,\n  .ad-frame.custom-list-ad .ad-container,\n  .ad-frame.homepage-ad .ad-content,\n  .ad-frame.detail-ad .ad-content,\n  .ad-frame.download-ad .ad-content,\n  .ad-frame.search-ad .ad-content,\n  .ad-frame.custom-list-ad .ad-content {\n    height: auto;\n    min-height: 0;\n  }\n\n  .ad-content .adsbygoogle {\n    width: 100%;\n  }\n\n  .ad-frame:has(.adsbygoogle[data-ad-status=\"unfilled\"]) {\n    display: none;\n  }\n}\n\n/* 确保广告内容居中显示 */\n.ad-content iframe,\n.ad-content ins,\n.ad-content div {\n  margin: 0 auto;\n}\n\n/* 广告加载时的占位样式 */\n.ad-container:empty::before {\n  content: '';\n  display: block;\n  width: 100%;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
